import { defineComponent as _defineComponent } from 'vue'
import {computed, getCurrentInstance} from 'vue';
import {useFormNavigation} from '@/components/calculator/form/useSimulationForm';
import {useSimulationStore} from '@/components/calculator/services/SimulationStore';
import {CalculatorVersion, useCalculatorVersion} from '@/components/calculator/useCalculatorVersion';
import {Routes} from '@/router/Routes';
import {ProductType} from '@/commons/enums/ProductType';
import SimulationToolbarZoom from '@/components/calculator/results/toolbar/SimulationToolbarZoom.vue';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';
import Deal from '@/models/Deal';
import SimulationDealPicker from '@/components/calculator/results/SimulationDealPicker.vue';
import {i18nFormatter} from '@/services/StringFormatter';


export default /*#__PURE__*/_defineComponent({
  __name: 'CalculatorNavigation',
  setup(__props) {

const store = useSimulationStore();
const {goBackToForm,} = useFormNavigation();
const {version,} = useCalculatorVersion();
const instance = getCurrentInstance();

const versionLabels = computed<string[]>(() => Object.keys(CalculatorVersion).filter(x => !(parseInt(x) >= 0)));
const newCalculatorSummaryRoutes: string[] = Object.values(ProductType)
  .map(productType => Routes.NEW_CALCULATOR.SUMMARY(productType));
const isSummaryRoute = computed<boolean>(() => newCalculatorSummaryRoutes.includes(instance?.proxy.$route.name ?? ''));

const onVersionChange = (version: CalculatorVersion) => {
  // TODO: Remove this after the new calculator is fully launched, it's responsible for refreshing the data during the transition from v1 to v2
  if (version === CalculatorVersion.V2) {
    store.init(store.productType!, store.simulationId, store.deal as Deal);
  }
};

const openLoadDealModal = async() => {
  const deal = await instance?.proxy.$modalService.open<Deal>(SimulationDealPicker, {
    productType: store.productType,
    simulationId: store.simulationId,
  }) ?? null;
  if (deal) {
    await store.init(store.productType!, deal?.simulationId, deal);
  }
};

const clear = async() => {
  const response = await instance?.proxy.$modalService.openConfirmModal({
    description: store.deal?.name ? i18nFormatter(
      I18NGetter().useCalculatorNavigationComponent.NEW_TRANSLATION_CLEAR_FORM_DESCRIPTION_DEAL,
      {dealName: store.deal?.name,})
      : I18NGetter().useCalculatorNavigationComponent.NEW_TRANSLATION_CLEAR_FORM_DESCRIPTION_NO_DEAL,
    title: I18NGetter().useCalculatorNavigationComponent.CLEAR_FORM_TITLE,
  }, I18NGetter().useCalculatorNavigationComponent.CANCEL, I18NGetter().useCalculatorNavigationComponent.CLEAR);
  if (response) {
    await store.clear();
    await store.createOrUpdateSimulation();
    instance?.proxy.$snackbarService.openSuccessSnackbar(
      I18NGetter().useCalculatorNavigationComponent.CLEAR_SUCCESS
    );
  }
};

return { __sfc: true,store, goBackToForm, version, instance, versionLabels, newCalculatorSummaryRoutes, isSummaryRoute, onVersionChange, openLoadDealModal, clear, CalculatorVersion, SimulationToolbarZoom, I18NGetter }
}

})